import { ToolUseProcessSupervisionStepResponse } from '@scale/shared/types/chat';

// If the observation, action, or action input changed, we need to reset the history
export const getShouldResetHistory = (
  response?: ToolUseProcessSupervisionStepResponse, // eslint-disable-line @typescript-eslint/no-unused-vars
  responseToSubmit?: ToolUseProcessSupervisionStepResponse, // eslint-disable-line @typescript-eslint/no-unused-vars
): boolean => {
  // TODO(@dannyadkins @averyyip): Align with operators on how they expect the response history to reset
  // That is, do we want it to reset if just the thought changed?
  // In any case, once we are collecting non-necessary fields like "justification", etc.,
  // we need to account for that logic to not reset.

  // if (!response || !responseToSubmit) return false;

  // const responseActions = response.context?.actions || [];
  // const responseToSubmitActions = responseToSubmit.context?.actions || [];

  // if (responseActions.length !== responseToSubmitActions.length) return true;

  // for (let i = 0; i < responseActions.length; i++) {
  //   const responseChunks = responseActions[i].chunks;
  //   const responseToSubmitChunks = responseToSubmitActions[i].chunks;

  //   for (const chunkName of ['Observation', 'Action', 'Action Input']) {
  //     const responseChunk = responseChunks.find(chunk => chunk.name === chunkName);
  //     const responseToSubmitChunk = responseToSubmitChunks.find(chunk => chunk.name === chunkName);

  //     if (!responseChunk && !responseToSubmitChunk) continue;

  //     if (!responseChunk || !responseToSubmitChunk) return true;

  //     const responseValue = responseChunk.rewriteValue || responseChunk.originalValue;
  //     const responseToSubmitValue =
  //       responseToSubmitChunk.rewriteValue || responseToSubmitChunk.originalValue;

  //     if (responseValue !== responseToSubmitValue) return true;
  //   }
  // }

  // For special case when the user force-select "finish" in the tool select dropdown,
  // which indicates the history beyond this turn should be reset
  if (!responseToSubmit) return false;
  if (response) {
    // If there was a previous response, we only want to reset if the content changed
    if (response.context.actions.length !== responseToSubmit.context.actions.length) return true;
    for (let i = 0; i < response.context.actions.length; i++) {
      const responseChunks = response.context.actions[i].chunks;
      const responseToSubmitChunks = responseToSubmit.context.actions[i].chunks;
      if (responseChunks.length !== responseToSubmitChunks.length) return true;
      for (let j = 0; j < responseChunks.length; j++) {
        const responseChunk = responseChunks[j];
        const responseToSubmitChunk = responseToSubmitChunks[j];
        if (responseChunk.name !== responseToSubmitChunk.name) return true;
        if (responseChunk.originalValue !== responseToSubmitChunk.originalValue) return true;
        if (responseChunk.rewriteValue !== responseToSubmitChunk.rewriteValue) return true;
        // we purposely do not check ratings as a rating can go from null to correct but we would not
        // want to reset the history in that case
      }
    }
    return false;
  }
  const responseToSubmitActions = responseToSubmit.context?.actions || [];
  for (const action of responseToSubmitActions) {
    const responseToSubmitChunks = action.chunks || [];
    const actionChunk = responseToSubmitChunks.find(chunk => chunk.name === 'Action');
    if (
      actionChunk?.rewriteValue !== actionChunk?.originalValue &&
      actionChunk?.type === 'tool_select' &&
      actionChunk?.rewriteValue === 'finish'
    ) {
      return true;
    }
    const observationChunk = responseToSubmitChunks.find(chunk => chunk.name === 'Observation');
    if (observationChunk?.rewriteValue !== observationChunk?.originalValue) {
      return true;
    }
  }
  return false;
};
